// The scoreboard utilities in here deal with a mismatch between the API
// configuration and how the UI wants to present the configuration.
//
// Starting with the standard `broadcast.scoreboard_configuration` object
// from the API, we introduce or change the following attributes:
//  * Split `sport` into `sport_prefix` and `sport_variation` in the UI to allow
//    a dependent selection between Basketball 4Q/2H
//  * Remove the idea of "Manual" as a scoreboard_make and flatten into a
//    top-level boolean option.
//  * Use a new notion of `connection` to switch between the 2 types of BoxCast
//    adapters as well as Sportzcast.

export function getUISports() {
  return [
    { label: 'Baseball / Softball', value: 'Baseball/Softball', icon: '/img/sports/baseball.svg' },
    { label: 'Basketball', value: 'Basketball', icon: '/img/sports/basketball.svg' },
    { label: 'Football', value: 'Football', icon: '/img/sports/football.svg' },
    { label: 'Hockey', value: 'Hockey', icon: '/img/sports/hockey.svg' },
    { label: 'Lacrosse', value: 'Lacrosse', icon: '/img/sports/lacrosse.svg' },
    { label: 'Soccer', value: 'Soccer', icon: '/img/sports/soccer.svg' },
    { label: 'Volleyball', value: 'Volleyball', icon: '/img/sports/volleyball.svg' },
    { label: 'Wrestling', value: 'Wrestling', icon: '/img/sports/wrestling.svg' },
  ];
}

export function getUIConnections(account) {
  var result = [];
  if (account.feature_flags.automated_scoreboard) {
    if (account.has_scoreboard_assists) {
      result.push({
        label: 'BoxCast Scoreboard Assist',
        value: 'scoreboard_assist',
        icon: '/img/sports/BoxCastScoreboardAssist.png',
        description: 'Supports Trans-Lux Fair-Play, Daktronics, and OES',
        is_new: true,
      });
    }
    result.push({
      label: 'BoxCast Scoreboard Adapter',
      value: 'scoreboard_adapter',
      icon: '/img/sports/BoxCastScoreBug.png',
      description: '(Legacy) Supports Trans-Lux Fair-Play, Daktronics, and OES',
    });
  }
  if (account.feature_flags.sportzcast) {
    result.push({
      label: 'ScoreBot',
      value: 'scorebot',
      icon: '/img/sports/SportzCastLogo.png',
      description: 'Requires Sportzcast log in',
    });
  }
  return result;
}

export function updateSportFromPrefix(scoreboard_configuration, sport_prefix) {
  scoreboard_configuration.sport_prefix = sport_prefix;
  if (sport_prefix == 'Basketball') {
    if (!scoreboard_configuration.sport_variation) {
      scoreboard_configuration.sport_variation = ' (4 Quarters)';
    }
    scoreboard_configuration.sport =
      scoreboard_configuration.sport_prefix + scoreboard_configuration.sport_variation;
  } else {
    scoreboard_configuration.sport = scoreboard_configuration.sport_prefix;
  }
  return scoreboard_configuration;
}

export function restoreScoreboardUIConfiguration(sc) {
  if (sc.scoreboard_make == 'Manual') {
    sc.manual = true;
  } else if (sc.scoreboard_make == 'BoxCast') {
    sc.manual = false;
    sc.connection = 'scoreboard_assist';
  } else if (sc.scoreboard_make == 'Sportzcast') {
    sc.manual = false;
    sc.connection = 'scorebot';
  } else if (sc.scoreboard_make) {
    sc.manual = false;
    sc.connection = 'scoreboard_adapter';
  }

  if (sc.sport) {
    if (sc.sport.startsWith('Basketball')) {
      sc.sport_prefix = 'Basketball';
      sc.sport_variation = sc.sport.replace('Basketball', '');
    } else {
      sc.sport_prefix = sc.sport;
      sc.sport_variation = '';
    }
  }
}

export function mapScoreboardUIConfigurationToAPI(sc) {
  if (sc.manual) {
    delete sc.manual;
    delete sc.connection;
    delete sc.sportzcast_bot_number;
    sc.scoreboard_make = 'Manual';
    sc.scoreboard_model = 'Manual Input';
  } else if (sc.connection == 'scoreboard_assist') {
    delete sc.manual;
    delete sc.connection;
    delete sc.sportzcast_bot_number;
    sc.scoreboard_make = 'BoxCast';
    sc.scoreboard_model = 'Scoreboard Assist';
  } else if (sc.connection == 'scorebot') {
    delete sc.manual;
    delete sc.connection;
    sc.scoreboard_make = 'Sportzcast';
    sc.scoreboard_model = 'ScoreBOT';
  } else if (sc.connection == 'scoreboard_adapter') {
    delete sc.manual;
    delete sc.connection;
    delete sc.sportzcast_bot_number;
  }

  if (sc.sport) {
    if (sc.sport_prefix == 'Basketball') {
      sc.sport = sc.sport_prefix + sc.sport_variation;
    } else {
      sc.sport = sc.sport_prefix;
    }
  }
  delete sc.sport_prefix;
  delete sc.sport_variation;
}

export function clearScoreboardConfig(sc) {
  sc.sport = null;
  sc.sport_prefix = null;
  sc.sport_variation = null;
  sc.scoreboard_make = null;
  sc.scoreboard_model = null;
  delete sc.connection;
  delete sc.manual;
}



// WEBPACK FOOTER //
// ./app/utils/scoreboard.js